import React from 'react';
import TopCategories from './TopCategories';
import Exclusively from './Exclusively';
import StoresServices from './StoresServices';
import Contact from './Contact';
import Banner from './banner';

const Home = () => {
  return (
    <>
      <Banner />
      <TopCategories />
      <Exclusively />
      <StoresServices />
      <Contact />
    </>
  );
};

export default Home;